import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { IConsultant_ECI } from "../../models/Consultant_ECI";
import { JVDate } from "../../shared/JVDate";
import { JVDropdown } from "../../shared/JVDropdown";
import { ECIType } from "../../models/FDropdown";
import { IECIStatusDropdown, ITimeZoneDropdown } from "../../models/IDropdown";
import { JVTime } from "../../shared/JVTime";
import { format } from 'date-fns';
import { EmptyECI } from "../eci/EmptyECI";
import { IRequirementMast, Job_Type, Req_Term } from "../../models/RequirementMast";
import { IEmailTemplate } from "../../models/EmailTemplate";
import { ISignatureMast } from "../../models/SignatureMast";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { Steps } from "primereact/steps";

const items = [{ label: ' ' }, { label: ' ' },];

const schema = yup.object({
    ecI_Date: yup.date().required("Date is required*").typeError("Date is required"),
    ecI_Time: yup.date().required("Time is required*").typeError("Time is required"),
    ecI_Time_Zone: yup.number().min(1, "Zone is required*").required("Zone is required*"),
    ecI_Type: yup.string().required("ECI Type is required*"),
    ecI_Client: yup.string().nullable(),
    ecI_InterviewrName: yup.string().nullable(),
    comments: yup.string().nullable(),
    email_Subject: yup.string().required("Email Subject is required"),
    ecI_Feedback_Status: yup.number().min(1, "Status is required*").required("Status is required*"),
});

interface Iprops {
    req_ID: number,
    submission_ID: number,
    client?: string,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    ShowCelebration: (type: string) => void,
}

export const FormEci = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [req, setReq] = useState<IRequirementMast>();
    const [timeZome, setTimeZone] = useState<ITimeZoneDropdown[]>();
    const [ecIStatus, setEciStatus] = useState<IECIStatusDropdown[]>();
    const [signature, setSignature] = useState("");
    const [signatureDisable, setSignatureDisable] = useState(true);
    const [mailBody, setMailBody] = useState("");
    const [activeIndex, setActiveIndex] = useState(0);
    const [loadEmail, setLoadEmail] = useState(true);

    const { control, handleSubmit, formState: { errors }, reset, setValue } = useForm<IConsultant_ECI>({
        resolver: yupResolver(schema),
        shouldFocusError: false,
        defaultValues: EmptyECI
    });

    useEffect(() => {
        setValue("ecI_Client", props.client);
    }, [props.client]);
    useEffect(() => {
        if (props.req_ID) loadRequirement(props.req_ID);
    }, [props.req_ID]);

    useEffect(() => {
        loadStatus();
        loadTimeZone();
        loadSignature();
    }, []);

    const loadRequirement = async (req_ID: number) => {
        const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${req_ID}`, props.toast);
        if (response) {
            const data: IRequirementMast = await response.json();
            setReq(data);
        }
    };

    const loadSignature = async () => {
        const response = await Fetch("Signature_Mast", "GET", null, null, props.toast);
        if (response) {
            const data: ISignatureMast = await response.json();
            if (data.signature) setSignature(data.signature);
        }
    }

    const generateMail = async () => {
        if (!errors.ecI_Date && !errors.ecI_Time && !errors.ecI_Time_Zone && !errors.ecI_Feedback_Status && req !== undefined) {
            const _timeZone = timeZome?.find(tz => tz.timezone_ID === control._formValues.ecI_Time_Zone);
            const _eciStatus = ecIStatus?.find(s => s.ecI_Type_ID === control._formValues.ecI_Feedback_Status);

            const location = req?.city_Name ? `${req?.city_Name || ''}, ${req?.state_Name || ''}` : '';
            const response = await Fetch("Email_Template/byName", "GET", null, `name=${"ECI-" + _eciStatus?.ecI_Type_Name}`, props.toast);
            if (response) {
                const data: IEmailTemplate = await response.json();
                if (data.template_Subject) setValue("email_Subject", data.template_Subject);

                const table = `<table>
            <thead>
                <th>RequirementID</th>
                <th>Job Title</th>
                <th>Job Type</th>
                <th>Job Term</th>
                <th>Location</th>
                <th>Duration</th>
                <th>End Client</th>
                <th>ECI Date</th>
                <th>Time & Zone</th>
                <th>Status</th>
            </thead>
            <tbody>
                <td>${req.req_ID}</td>
                <td>${req.req_Job_Title}</td>
                <td>${Job_Type[req.job_Type || 0]}</td>
                <td>${Req_Term[req.req_Term || 0]}</td>
                <td>${location}</td>
                <td>${req.req_Duration}</td>
                <td>${req.req_EndClient}</td>
                <td>${format(new Date(control._formValues.ecI_Date), 'dd/MM/yyyy').toUpperCase()}</td>
                <td>${format(new Date(control._formValues.ecI_Time), 'hh:mm a').toUpperCase()} ${_timeZone?.time_Zone_Name}</td>
                <td>${_eciStatus?.ecI_Type_Name}</td>
            </tbody>
        </table>
        <p><b>Job Description -</b> \n${req.req_JobDescription}</p>`;
                setMailBody(data.template_Body + "<br/>" + table);
                setLoadEmail(true);
            }
        } else props.toast.current.show({ severity: 'error', detail: "first fill all the above required details.", life: 3000 });
    };

    const loadStatus = async () => {
        const response = await Fetch("Dropdown/ecI_status", "GET", null, null, null);
        if (response) {
            const data: Array<IECIStatusDropdown> = await response.json();
            const dataDd = data.filter(d => d.ecI_Type_ID === 1);
            setEciStatus(dataDd);
        }
    }

    const loadTimeZone = async () => {
        const response = await Fetch("Dropdown/timezone", "GET", null, null, null);
        if (response) {
            const data: Array<ITimeZoneDropdown> = await response.json();
            setTimeZone(data);
        }
    }

    const saveToDB = async (body: IConsultant_ECI) => {
        setLoading(true);
        const response = await Fetch("ECI", "POST", body, null, props.toast);

        if (response) {
            const data = await response.json();
            if (data.salesTargetCompleted === true) {
                props.ShowCelebration(data.type);
            }
            props.toast.current.show({ severity: 'success', detail: "Added Successfully.", life: 3000 });
            onHide();
            props.setReload(!props.reload);
            setLoading(false);
        } else setLoading(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyECI);
        setSignatureDisable(true);
        setMailBody('');
        setActiveIndex(0);
    }

    function onSubmit(data: IConsultant_ECI) {
        data.req_ID = props.req_ID;
        data.submission_ID = props.submission_ID;
        if (data.ecI_Time !== null && data.ecI_Time !== undefined) data.ecI_Time = format(new Date(data.ecI_Time), 'hh:mm a').toUpperCase();
        if (data?.ecI_Date instanceof Date) {
            const localDob = new Date(data.ecI_Date.getTime() - data.ecI_Date.getTimezoneOffset() * 60000);
            (data.ecI_Date as any) = localDob.toISOString();
        }
        if (mailBody.length < 1) props.toast.current.show({ severity: 'error', content: "Email Body is Required." });
        else {
            data.email_Body = mailBody;
            data.email_signature = signature;
            saveToDB(data);
        }
    }

    const OnNext = () => {
        if (control._formValues.ecI_Date !== null && control._formValues.ecI_Time !== null && (control._formValues.ecI_Time_Zone !== 0 && control._formValues.ecI_Time_Zone !== null) && (control._formValues.ecI_Feedback_Status !== 0 && control._formValues.ecI_Feedback_Status !== null)) {
            if (control._formValues.ecI_Feedback_Status === 11 || control._formValues.ecI_Feedback_Status === 3 || control._formValues.ecI_Feedback_Status === 9 || control._formValues.ecI_Feedback_Status === 8) {
                if (control._formValues.comments != null && control._formValues.comments != "") {
                    setActiveIndex(1);
                    generateMail();
                }
            } else {
                setActiveIndex(1);
                generateMail();
            }
        }
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add ECI" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <Steps className="w-full" model={items} activeIndex={activeIndex} readOnly={false} />
                <div style={{ margin: '10px 0', width: '100%' }}></div>
                {activeIndex === 0 && <>

                    <JVDate column={3} label="Date" required control={control} name="ecI_Date" error={errors.ecI_Date?.message} />
                    <JVTime column={3} label="Time" required control={control} name="ecI_Time" error={errors.ecI_Time?.message} />

                    <JVDropdown column={3} label="Zone" required control={control} name="ecI_Time_Zone" optionLabel="time_Zone_Name"
                        optionValue="timezone_ID" options={timeZome} placeholder="Select Time Zone" error={errors.ecI_Time_Zone?.message} />

                    <JVDropdown column={3} label="Type" required control={control} name="ecI_Type" optionLabel="name" optionValue="name"
                        options={ECIType} placeholder="Select ECI Type" error={errors.ecI_Type?.message} />

                    <JVInput column={3} label="Client" control={control} name="ecI_Client" />
                    <JVInput column={3} label="Interviewer Name" control={control} name="ecI_InterviewrName" error={errors.ecI_InterviewrName?.message} />
                    <JVDropdown column={3} label="Status" required control={control} name="ecI_Feedback_Status" optionLabel="ecI_Type_Name"
                        optionValue="ecI_Type_ID" options={ecIStatus} placeholder="Select Status" error={errors.ecI_Feedback_Status?.message} />
                    <JVInput column={3} label="Comments" control={control} name="comments" error={errors.comments?.message} />
                    <div className="field col-12 md:col-12">
                        {activeIndex < 1 && <Button className="field col-12 md:col-6" onClick={OnNext} label='NEXT'></Button>}
                        <Button className="className=field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                    </div>
                </>
                }

                {activeIndex === 1 && loadEmail && <>
                    <JVInput column={1} label="Email Subject" control={control} name="email_Subject" error={errors.email_Subject?.message} />
                    <div className="col-12 md:col-12 md:col-12">
                        {/* <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "flex-end" }}>
                            <label>Email Body</label>
                            <div className="m-1">
                                <Button label="Fill Email Body" type="button" icon="pi pi-envelope" className="p-button p-button-danger" onClick={generateMail} />
                            </div>
                        </div> */}
                        <JVSunEditor value={mailBody} handleChange={setMailBody} />
                    </div>

                    <div className="col-12 md:col-12 md:col-12">
                        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: "flex-end" }}>
                            <label>Signature</label>
                            <div className="m-1">
                                <Button type="button" icon="pi pi-pencil" className="p-button-rounded p-button-text" onClick={() => setSignatureDisable(!signatureDisable)} />
                            </div>
                        </div>
                        <JVSunEditor value={signature} handleChange={setSignature} disable={signatureDisable} />
                    </div>

                    <div style={{ margin: '10px 0', width: '100%' }}></div>
                    {/* <div className="field col-12 md:col-4">
                        <Button loading={loading} label="SAVE" type="submit"></Button>
                        <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                    </div> */}
                    <div className="field col-12 md:col-12">
                        {activeIndex > 0 && <Button className="className=field col-12 md:col-6 p-button-outlined" onClick={() => setActiveIndex(activeIndex - 1)} label='PREVIOUS'></Button>}
                        <Button className="field col-12 md:col-6 mt-3" loading={loading} label="SAVE" type="submit"></Button>
                        <Button className="className=field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                    </div>
                </>
                }
            </form>
        </Dialog>
    );
}
